module.exports = __webpack_public_path__ + "07e4a9b340ddd80a226b5515d70d51e0.svg";